import React from "react";
import { useMediaQuery } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import MediaFilesCard from "../creator-application/dashboard/MediaFilesCard";
import RecentModulesCard from "../components/dashboard/RecentModulesCard";
import AdminReportsCard from "./AdminReportsCard";
import ContentGroupsCard from "../creator-application/dashboard/ContentGroupsCard";

const AdminDashboard = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.up("md"));
  return (
    <Grid container spacing={5}>
      <Grid
        item
        container
        direction={isMd ? "column" : "row"}
        spacing={5}
        xs={12}
        md={9}
      >
        <Grid
          item
          container
          spacing={5}
          direction={isMd ? "row" : "column"}
          xs
          md
        >
          <Grid item md={4}>
            <RecentModulesCard />
          </Grid>

          <Grid item md>
            <MediaFilesCard />
          </Grid>
        </Grid>

        <Grid item xs="auto">
          {isMd ? <ContentGroupsCard /> : <AdminReportsCard />}
        </Grid>
      </Grid>

      <Grid item xs={12} md={3}>
        {isMd ? <AdminReportsCard /> : <ContentGroupsCard />}
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
